import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  padding: 50px 0;
`

const Text = styled.div`
  font-weight: 300;
  text-align: center;
  `

const BlockQuote = styled(Text)`
  margin: 0 0 70px;
  padding: 0;
  border: 0;
  color: ${props => props.theme.colors.tones.light};
  font-size: 30px;
  line-height: 38px;
  margin-bottom: 30px;

  p {
    margin-bottom: 0;
  }

  ${media.xs`
    font-size: 22px;
    line-height: 28px;
  `}

  ${media.xl`
    margin-bottom: 40px;
  `}
`

const Name = styled(Text)`
  font-size: 18px;
  color: ${props => props.theme.colors.primary};
  line-height: 25px;
  font-weight: 600;

  ${media.xs`
    font-size: 16px;
    line-height: 22px;
  `}
`

const Title = styled(Text)`
  font-size: 14px;
  line-height: 28px;

  ${media.xs`
    font-size: 12px;
  `}
`

export default class Quote extends Component {
  render() {
    const {
      quote,
      name,
      title
    } = this.props
    
    return (
      <Wrapper>
        <Container fluid>
          <Row>
            <Col
              sm={8}
              smOffset={2}
            >
              <BlockQuote
                dangerouslySetInnerHTML={{ __html: quote }}
                as="blockquote"
              />
              <Name>{name}</Name>
              <Title>{title}</Title>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Quote/index.js